/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Chip_200kInputs */

const tr_landing_genius_chip_200k = /** @type {(inputs: Landing_Genius_Chip_200kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`200K kredi`)
};

const en_landing_genius_chip_200k = /** @type {(inputs: Landing_Genius_Chip_200kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`200K credits`)
};

const de_landing_genius_chip_200k = /** @type {(inputs: Landing_Genius_Chip_200kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`200K Credits`)
};

const ru_landing_genius_chip_200k = /** @type {(inputs: Landing_Genius_Chip_200kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`200K кредитов`)
};

/**
* | output |
* | --- |
* | "200K credits" |
*
* @param {Landing_Genius_Chip_200kInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_chip_200k = /** @type {((inputs?: Landing_Genius_Chip_200kInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Chip_200kInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_chip_200k(inputs)
	if (locale === "de") return de_landing_genius_chip_200k(inputs)
	if (locale === "ru") return ru_landing_genius_chip_200k(inputs)
	return tr_landing_genius_chip_200k(inputs)
});